import { render, staticRenderFns } from "./newPersonFile.vue?vue&type=template&id=8a671106&scoped=true&"
import script from "./newPersonFile.vue?vue&type=script&lang=js&"
export * from "./newPersonFile.vue?vue&type=script&lang=js&"
import style0 from "./newPersonFile.vue?vue&type=style&index=0&id=8a671106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a671106",
  null
  
)

export default component.exports